export const TIERS_OPTIONS = [1, 2, 3, 4, 5];
